import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class CropImageService {
  public resizeAndCropImage(file: File, targetWidth: number, targetHeight: number): Promise<File> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (readerEvent: any) => {
        const image = new Image();
        image.src = readerEvent.target.result;

        const { ctx, canvas } = this.createCanvas(targetWidth, targetHeight);
        image.onload = () => {
          const { x, y, cropWidth, cropHeight } = this.getCroppedImageDimension(image, targetWidth, targetHeight);

          ctx.drawImage(image, x, y, cropWidth, cropHeight, 0, 0, targetWidth, targetHeight);

          canvas.toBlob((blob) => {
            const resizedFile = new File([blob], file.name, { type: file.type });
            resolve(resizedFile);
          }, file.type);
        };
      };
    });
  }

  private createCanvas(targetWidth: number, targetHeight: number) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = targetWidth;
    canvas.height = targetHeight;

    return { ctx, canvas };
  }

  private getCroppedImageDimension(image: HTMLImageElement, targetWidth: number, targetHeight: number) {
    const imageRatio = image.width / image.height;
    const targetRatio = targetWidth / targetHeight;

    if (imageRatio > targetRatio) {
      return this.cropHorizontally(image, targetRatio);
    }

    return this.cropVertically(image, targetRatio);
  }
  private cropHorizontally(image: HTMLImageElement, targetRatio: number) {
    const cropWidth = image.height * targetRatio;
    return { cropHeight: image.height, cropWidth, x: (image.width - cropWidth) / 2, y: 0 };
  }

  private cropVertically(image: HTMLImageElement, targetRatio: number) {
    const cropHeight = image.width / targetRatio;
    return { cropHeight, cropWidth: image.width, x: 0, y: (image.width - cropHeight) / 2 };
  }
}
